const TestModeBanner = () => {
	return (
		<div>
			<b>You are in Testing Mode. </b> All data provided is
			non-production and simulated for testing purposes
		</div>
	);
};

export default TestModeBanner;